const getTranslation = (languageContent, locale, fallback) => {
  let result = languageContent[locale ?? fallback];
  if (fallback && !result) {
    result = languageContent[fallback];
  }
  return result;
};
export {
  getTranslation
};
//# sourceMappingURL=getTranslation.mjs.map